/**
 * Resolve the element an anchor link points at.
 *
 * Deliberately `getElementById` instead of `querySelector`: anchors are free text typed by
 * editors in the CMS, so they can contain spaces or start with a digit. Those are invalid CSS
 * selectors and would make `querySelector` throw, while `getElementById` matches them fine.
 *
 * @param hash - The anchor, with or without a leading `#`
 */
export const getAnchorElement = (hash: string): HTMLElement | null => {
  const id = hash.replace(/^#+/, '')

  if (!id) {
    return null
  }

  // CMS anchors with special characters end up percent-encoded in the URL, the `id` attribute is not.
  let decoded = id
  try {
    decoded = decodeURIComponent(id)
  } catch {
    // Malformed escape sequence: fall back to the raw value.
  }

  return document.getElementById(decoded) ?? document.getElementById(id)
}
